import Link from 'next/link'
import React, { useContext, useRef } from 'react'
import classNames from 'classnames'
import { SharedContext } from '@/context/SharedContext'

export const NextLink = ({
  children,
  onClick,
  isLoader = true,
  as,
  disabled = false,
  ...props
}) => {
  const enable = useRef(true)
  const { setSkeletonloader, setHistoryStack } = useContext(SharedContext)
  return (
    <Link
      {...{ ...props }}
      as={(as || '').toLowerCase()}
      className={classNames('no-underline', props?.className)}
      onClick={async (e) => {
        if (disabled) {
          e.preventDefault()
          return
        }
        if (enable.current && !!onClick && !disabled) {
          e.preventDefault()
          const element = document?.getElementById(props.id)
          if (isLoader)
            setSkeletonloader?.({
              isVisible: true,
              pathName: props?.href?.pathname?.split('/')?.[1]
            })
          const details = await onClick()
          setSkeletonloader?.({
            isVisible: false,
            pathName: props?.href?.pathname?.split('/')?.[1]
          })

          if (!details || typeof details == 'object') {
            enable.current = false
            if (props?.replace)
              setHistoryStack((prv) => {
                prv?.data?.pop()
                return { ...prv }
              })
            if (details?.isNewPath) {
              location.href = (details?.newPath || '').toLowerCase()
            } else element?.click()
          }
        } else if (enable.current && props?.replace)
          setHistoryStack((prv) => {
            prv?.data?.pop()
            return { ...prv }
          })
      }}
    >
      {children}
    </Link>
  )
}
